<template>
    <div class="menu_table">
        <!-- 按钮布局 -->
        <div class="leader-tab">
            <el-tabs v-model="tabVal" type="card" @tab-click="handleTabClick">
                <el-tab-pane label="资源url" name="2"></el-tab-pane>
                <el-tab-pane label="资源按钮" name="3"></el-tab-pane>
            </el-tabs>
            <div class="btnContainer">
                <el-form
                    class="leader-style-form leader-form-inline"
                    style="margin-right: 20px; width: 100%"
                >
                    <el-row :gutter="10">
                        <el-col
                            :offset="18"
                            :span="6"
                            style="text-align: right"
                        >
                            <!-- <el-button
                                v-if="tabVal == '3'"
                                @click="addBtn({}, '新增按钮')"
                                size="small"
                                >新增btn</el-button
                            > -->

                            <div v-if="tabVal == '2'">
                                <el-button @click="addItem" size="small"
                                    >新增</el-button
                                >
                            </div>
                            <div v-else>
                                <el-button
                                    v-if="tabVal == '3'"
                                    @click="addBtn({}, '新增按钮')"
                                    size="small"
                                    >新增</el-button
                                >
                            </div>
                            <!--  -->
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>

        <!-- -------------------------- -->
        <!-- table布局 -->
        <div
            class="table-wrap"
            style="height: calc(100% - 3rem); width: 100%"
        >
            <el-table
                class="leader-style-table"
                :data="tableList"
                height="90%"
                ref="multipleTable"
                v-if="tabVal == '2'"
            >
                <el-table-column
                    type="index"
                    width="50"
                    align="center"
                    label="序号"
                    property="num"
                ></el-table-column>
                <el-table-column
                    label="资源名称"
                    property="resource_name"
                ></el-table-column>
                <el-table-column
                    label="资源url"
                    property="resource_url"
                ></el-table-column>
                <el-table-column
                    label="验证权限"
                    property="check_auth_name"
                    width="100"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="记录日志"
                    property="log_type_name"
                    width="100"
                    align="center"
                ></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="changeItem(scope.row)"
                            type="text"
                            class="leader-button edit-button"
                        >
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button
                            @click="deleteItemShow(scope.row)"
                            type="text"
                            class="leader-button del-button"
                        >
                            <i class="iconfont iconashbin"></i>
                            <span class="inner-text">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-table
                height="100%"
                class="leader-style-table"
                :data="tableList"
                ref="multipleTable"
                v-else
            >
                <el-table-column
                    type="index"
                    width="50"
                    align="center"
                    label="序号"
                    property="num"
                ></el-table-column>
                <el-table-column
                    label="按钮名称"
                    property="button_name"
                ></el-table-column>
                <el-table-column
                    label="按钮id"
                    property="button_key"
                ></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="addBtn(scope.row, '修改按钮')"
                            type="text"
                            class="leader-button edit-button"
                        >
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button
                            @click="deleteBtn(scope.row)"
                            type="text"
                            class="leader-button del-button"
                        >
                            <i class="iconfont iconashbin"></i>
                            <span class="inner-text">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                class="leader-style-pagination"
                :paginationData="paginationData"
                @paginationDataNew="paginationDataNew"
                v-if="this.paginationData.totalNum"
            ></pagination>
        </div>
        <!-- -------------------------------- -->
        <!-- 新增dialog -->
        <el-dialog
            title="菜单管理"
            class="leader-dialog"
            :visible.sync="addshow"
            :close-on-click-modal="false"
            @close="dialogClose('addForm')"
        >
            <el-form
                label-width="150px"
                :model="addForm"
                :rules="addRules"
                ref="addForm"
                class="leader-style-form"
            >
                <el-form-item label="资源名称" prop="resource_name">
                    <el-input
                        maxlength="20"
                        v-model="addForm.resource_name"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="资源url" prop="resource_url">
                    <el-input
                        maxlength="100"
                        v-number-input="addForm.resource_url"
                        v-model="addForm.resource_url"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="验证权限"
                    style="text-align: left"
                    prop="check_auth"
                >
                    <el-radio-group v-model="addForm.check_auth">
                        <el-radio label="0">否</el-radio>
                        <el-radio label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="记录日志"
                    style="text-align: left"
                    prop="log_type"
                >
                    <el-radio-group v-model="addForm.log_type">
                        <el-radio label="0">否</el-radio>
                        <el-radio label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button
                    @click="addshow = false"
                    class="leader-common-button"
                    size="small"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    @click="addcommit"
                    :disabled="this.$store.state.btnType"
                    size="small"
                    class="leader-common-button"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
        <!-- ------------------------------------ -->
        <!-- 修改dialog -->
        <el-dialog
            title="菜单管理"
            class="leader-dialog"
            :visible.sync="editshow"
            :close-on-click-modal="false"
            @close="dialogClose('editForm')"
        >
            <el-form
                label-width="150px"
                :model="editForm"
                :rules="editRules"
                class="leader-style-form"
                ref="editForm"
            >
                <el-form-item label="资源名称" prop="resource_name">
                    <el-input
                        maxlength="20"
                        v-model="editForm.resource_name"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="资源url" prop="resource_url">
                    <el-input
                        maxlength="100"
                        v-model="editForm.resource_url"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="验证权限"
                    style="text-align: left"
                    prop="check_auth"
                >
                    <el-radio-group v-model="editForm.check_auth">
                        <el-radio label="0">否</el-radio>
                        <el-radio label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="记录日志"
                    style="text-align: left"
                    prop="log_type"
                >
                    <el-radio-group v-model="editForm.log_type">
                        <el-radio label="0">否</el-radio>
                        <el-radio label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button
                    @click="editshow = false"
                    class="leader-common-button"
                    size="small"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    @click="editcommit"
                    :disabled="this.$store.state.btnType"
                    size="small"
                    class="leader-common-button"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
        <btn-dialog
            :btnVsb.sync="btnVsb"
            :title="title"
            :menuId="menuId"
            :btnId="btnId"
            @closeCb="closeBtnDialogCb"
        ></btn-dialog>
        <!-- ------------------------------------ -->
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import pagination from "@/comon/components/pagination.vue";
import BtnDialog from "./components/btn-dialog";
export default {
    components: {
        pagination,
        BtnDialog
    },
    props: ["treeId"],
    data() {
        return {
            tableList: [],
            tableId: "",
            paginationData: {
                pageNum: "",
                pageSize: "",
                totalNum: ""
            },
            addshow: false,
            addForm: {
                resource_name: "",
                resource_url: "",
                menu_id: "",
                check_auth: "1",
                log_type: "1"
            },
            addRules: {
                resource_name: [
                    {
                        required: true,
                        message: "请填写资源名称",
                        trigger: "blur"
                    }
                ],
                resource_url: [
                    {
                        required: true,
                        message: "请输入资源url",
                        trigger: "blur"
                    }
                ],
                check_auth: [
                    {
                        required: true,
                        message: "请选择是否验证权限",
                        trigger: "change"
                    }
                ],
                log_type: [
                    {
                        required: true,
                        message: "请选择是否记录日志",
                        trigger: "change"
                    }
                ]
            },
            flag: true,
            editshow: false,
            editForm: {
                resource_name: "",
                resource_url: "",
                menu_id: "",
                check_auth: "",
                log_type: "",
                resource_id: ""
            },
            editRules: {
                resource_name: [
                    {
                        required: true,
                        message: "请填写资源名称",
                        trigger: "blur"
                    }
                ],
                resource_url: [
                    {
                        required: true,
                        message: "请输入资源url",
                        trigger: "blur"
                    }
                ],
                check_auth: [
                    {
                        required: true,
                        message: "请选择是否验证权限",
                        trigger: "change"
                    }
                ],
                log_type: [
                    {
                        required: true,
                        message: "请选择是否记录日志",
                        trigger: "change"
                    }
                ]
            },
            tabVal: "",
            btnVsb: false,
            title: "新增按钮",
            menuId: "",
            btnId: "",
            loading: false
        };
    },
    created() {
        this.tabVal = "2";
    },
    methods: {
        // 获取table
        getUrlsByMenuId() {
            this.loading = true;
            api.getUrlsByMenuId({
                menu_id: this.tableId,
                pageNum: this.paginationData.pageNum,
                pageSize: this.paginationData.pageSize
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.tableList = res.bus_json.items;
                    this.paginationData.pageNum = res.bus_json.pageNum;
                    this.paginationData.pageSize = res.bus_json.pageSize;
                    this.paginationData.totalNum = res.bus_json.totalNum;
                    this.$refs.multipleTable.doLayout();
                }
                this.loading = false;
            });
        },
        getButtonList() {
            this.loading = true;
            api.getButtonList({
                menu_id: this.tableId,
                pageNum: this.paginationData.pageNum,
                pageSize: this.paginationData.pageSize
            }).then(res => {
                this.tableList = res.bus_json.items;
                this.paginationData.pageNum = res.bus_json.pageNum;
                this.paginationData.pageSize = res.bus_json.pageSize;
                this.paginationData.totalNum = res.bus_json.totalNum;
                this.$refs.multipleTable.doLayout();
            });
            this.loading = false;
        },
        //  table新增按钮点击
        addItem() {
            this.addForm = {
                resource_name: "",
                resource_url: "",
                menu_id: "",
                check_auth: "1",
                log_type: "1"
            };
            if (this.tableId) {
                this.addshow = true;
            }
        },
        // 分页器公共方法
        paginationDataNew(sth) {
            this.paginationData = sth;
            if (this.tabVal == "2") {
                this.getUrlsByMenuId();
            } else {
                this.getButtonList();
            }
        },
        // 新增资源提交
        addcommit() {
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    if (this.flag) {
                        api.menuUrlsTableAddCommit({
                            resource_id: "",
                            resource_name: this.addForm.resource_name,
                            resource_url: this.addForm.resource_url,
                            menu_id: this.tableId,
                            check_auth: this.addForm.check_auth,
                            log_type: this.addForm.log_type
                        }).then(res => {
                            if (res && res.error_code === "0") {
                                this.addshow = false;
                                this.$message({
                                    message: res.error_msg,
                                    type: "success"
                                });
                                this.getUrlsByMenuId();
                                setTimeout(() => {
                                    this.flag = true;
                                }, 1500);
                            }
                        });
                    }
                }
            });
        },
        // 所有关闭dialog的清除验证的回调
        dialogClose(formName) {
            this.$nextTick(() => {
                this.$refs[formName].resetFields();
            });
        },
        // table内点击修改弹窗
        changeItem(sth) {
            this.editForm = {
                resource_name: "",
                resource_url: "",
                menu_id: "",
                check_auth: "",
                log_type: "",
                resource_id: ""
            };
            api.getUrlInfoByResourceId({
                resource_id: sth.resource_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.editForm = {
                        resource_name: res.bus_json.resource_name,
                        resource_url: res.bus_json.resource_url,
                        menu_id: res.bus_json.menu_id,
                        check_auth: res.bus_json.check_auth,
                        log_type: res.bus_json.log_type,
                        resource_id: res.bus_json.resource_id
                    };
                    this.editshow = true;
                }
            });
        },
        // menuTable修改dialog提交
        editcommit() {
            this.$refs["editForm"].validate(valid => {
                if (valid) {
                    if (this.flag) {
                        api.menuUrlsTableAddCommit({
                            resource_id: this.editForm.resource_id,
                            resource_name: this.editForm.resource_name,
                            resource_url: this.editForm.resource_url,
                            menu_id: this.tableId,
                            check_auth: this.editForm.check_auth,
                            log_type: this.editForm.log_type
                        }).then(res => {
                            if (res && res.error_code === "0") {
                                this.editshow = false;
                                this.$message({
                                    message: res.error_msg,
                                    type: "success"
                                });
                                this.getUrlsByMenuId();
                                setTimeout(() => {
                                    this.flag = true;
                                }, 1500);
                            }
                        });
                    }
                }
            });
        },
        // 删除menuTable的一项
        deleteItemShow(sth) {
            this.$confirm("确认删除该数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.delUrl({
                        resource_id: sth.resource_id
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            if (
                                this.paginationData.totalNum -
                                    (this.paginationData.pageNum - 1) *
                                        this.paginationData.pageSize ==
                                1
                            ) {
                                this.paginationData.pageNum =
                                    this.paginationData.pageNum == 1
                                        ? this.paginationData.pageNum
                                        : this.paginationData.pageNum - 1;
                            }
                            this.getUrlsByMenuId();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "未删除"
                    });
                });
        },
        handleTabClick(tab) {
            this.tabVal = tab.name;
            this.paginationData = {
                pageNum: "1",
                pageSize: "10",
                totalNum: ""
            };
            this.tableList = [];
            if (this.tabVal == "2" && this.tableId) {
                this.getUrlsByMenuId();
            } else if (this.tabVal == "3" && this.tableId) {
                this.getButtonList();
            }
        },
        addBtn(row, title) {
            if (!this.tableId.length) {
                return;
            }
            this.title = title;
            if (row) {
                this.btnId = row.button_id;
            }
            this.menuId = this.tableId;
            this.btnVsb = true;
        },
        closeBtnDialogCb() {
            this.paginationData = {
                pageNum: "1",
                pageSize: "10",
                totalNum: ""
            };
            this.tableList = [];
            if (this.tabVal == "2") {
                this.getUrlsByMenuId();
            } else {
                this.getButtonList();
            }
        },
        deleteBtn(row) {
            this.$confirm("确认删除该数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.delButton({
                        button_id: row.button_id
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.btnId = "";
                            if (
                                this.paginationData.totalNum -
                                    (this.paginationData.pageNum - 1) *
                                        this.paginationData.pageSize ==
                                1
                            ) {
                                this.paginationData.pageNum =
                                    this.paginationData.pageNum == 1
                                        ? this.paginationData.pageNum
                                        : this.paginationData.pageNum - 1;
                            }
                            this.getButtonList();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "未删除"
                    });
                });
        }
    },
    watch: {
        treeId(val) {
            this.paginationData = {
                pageNum: "1",
                pageSize: "10",
                totalNum: ""
            };
            this.tableId = val;
            this.tableList = [];
            if (this.tabVal == "2") {
                this.getUrlsByMenuId();
            } else {
                this.getButtonList();
            }
        }
    }
};
</script>
<style lang="scss">
.menu_table {
    height: 100%;
    .tableContainer {
        width: 100%;
        el-table {
            width: 100%;
        }
    }
    .color_green {
        color: #009788;
    }
    .color_red {
        color: red;
    }
    .leader-tab {
        position: relative;
        .btnContainer {
            width: auto;
            position: absolute;
            right: 2rem;
            top: -2rem;
        }
    }
}
</style>
